import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Avatar,
  Box,
} from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import { IUsuario, useUsuario } from "../../../../Hooks/UsuarioHook";
import { useUsuarioStorage } from "../../../../Storage/UsuariosStorage";
import { api_login_unico_url } from "../../../../Utils/Urls";

interface UpdatePhotoModalProps {
  open: boolean;
  onClose: () => void;
}

export const EditarFotoDePerfilModal: React.FC<UpdatePhotoModalProps> = ({
  open,
  onClose,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [confirmOpen, setConfirmOpen] = useState(false); // controle do modal de confirmação
  const { usuario } = useUsuario();
  const { usuarioFocus, atualiza_criaUsuario, setUsuarioFocus } =
    useUsuarioStorage();

  const handleClose = () => {
    onClose();
    setSelectedFile(null);
    setConfirmOpen(false);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setSelectedFile(file);
    }
  };

  // Abre modal de confirmação
  const handleUpdatePhotoClick = () => {
    if (selectedFile) {
      setConfirmOpen(true);
    }
  };

  // Executa a atualização após a confirmação
  const handleConfirmUpdate = async (replicar: boolean) => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("id", usuarioFocus.usuario.id.toString());
    formData.append("cpf", usuarioFocus.usuario.cpf);

    try {
      const help = await atualiza_criaUsuario(formData, replicar);
      const usuario_ = {} as IUsuario;
      usuario_.usuario = help;
      usuario_.usuario.foto = usuario_.usuario.foto;
      setUsuarioFocus(usuario_);
      console.log("Foto de perfil atualizada com sucesso:", selectedFile.name);
      handleClose();
    } catch (error) {
      console.error("Erro ao atualizar a foto:", error);
    }
  };

  return (
    <>
      {/* Modal de upload */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <Typography variant="h6" color="primary">
            Atualizar Foto de Perfil
          </Typography>
        </DialogTitle>
        <DialogContent>
          <input
            type="file"
            accept="image/*"
            id="update-photo-input"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <label
            htmlFor="update-photo-input"
            style={{ display: "block", cursor: "pointer" }}
          >
            <Box
              sx={{
                width: 150,
                height: 150,
                margin: "auto",
                borderRadius: "50%",
                border: "2px dashed",
                borderColor: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                bgcolor: selectedFile ? "transparent" : "action.hover",
                overflow: "hidden",
                textAlign: "center",
              }}
            >
              {selectedFile ? (
                <Avatar
                  src={URL.createObjectURL(selectedFile)}
                  alt="Preview"
                  sx={{ width: "100%", height: "100%" }}
                />
              ) : (
                <>
                  <PhotoCamera sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                  <Typography variant="body2" color="primary">
                    Clique ou arraste a foto
                  </Typography>
                </>
              )}
            </Box>
          </label>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleUpdatePhotoClick} color="primary">
            Atualizar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de confirmação */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>
          <Typography variant="h6" color="primary">
            Confirmar Atualização
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Deseja atualizar esta foto em todas as entidades do usuário?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => handleConfirmUpdate(false)} color="primary">
            Apenas nesta entidade
          </Button>
          <Button onClick={() => handleConfirmUpdate(true)} color="primary">
            Atualizar em todas
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
